export let props = ['title']
export let model = {
}
export let computed = {
}
